import axios from 'axios';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { getContextId } from '../lib/TaxonomyUtils';
import { fixExerciseStructure } from '../lib/exerciseTransformations/fixExerciseStructure';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function getInvalsiHomeworkList(traceData = {}, subjectsId = [], fromYearOrdinal = null, toYearOrdinal = null, favouriteOnly = false, searchPage = 0) {
    searchPage++;
    const url = `${API_URL}/cv/homeworkInvalsi`;
    return async dispatch => {
        dispatch({
            type: searchPage === 1 ? types.GET_INVALSI_HOMEWORK_LIST : types.GET_MORE_INVALSI_HOMEWORK_LIST,
            payload: {
                favouriteOnly,
                subjectsId,
                fromYearOrdinal,
                toYearOrdinal,
                traceData
            }
        });
        try {
            let paramArray = [];

            if (subjectsId && subjectsId.length > 0) {
                paramArray.push(`subjects=${JSON.stringify(subjectsId)}`);
            }

            if (fromYearOrdinal && fromYearOrdinal !== '') {
                paramArray.push(`fromChapterOrdinal=${fromYearOrdinal}`);
            }

            if (toYearOrdinal && toYearOrdinal !== '') {
                paramArray.push(`toChapterOrdinal=${toYearOrdinal}`);
            }

            paramArray.push(`favourite=${favouriteOnly}`);
            paramArray.push(`page=${searchPage}`);
            paramArray.push(`etag=${Math.random() * 1000}`);

            const {
                data: { data, totalCount }
            } = await axios.get(`${url}?${paramArray.join('&')}`);
            dispatch({
                type: searchPage === 1 ? types.GET_INVALSI_HOMEWORK_LIST_SUCCESS : types.GET_MORE_INVALSI_HOMEWORK_LIST_SUCCESS,
                payload: {
                    result: data,
                    searchPage,
                    totalCount
                }
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: searchPage === 1 ? types.GET_INVALSI_HOMEWORK_LIST_UNAUTHORIZED : types.GET_MORE_INVALSI_HOMEWORK_LIST_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: searchPage === 1 ? types.GET_INVALSI_HOMEWORK_LIST_FAILURE : types.GET_MORE_INVALSI_HOMEWORK_LIST_FAILURE,
                    error: e
                });
            }
        }
    };
}

export function getInvalsiSubjects() {
    const url = `${API_URL}/taxonomies/subjects/cv?origin=INVALSI`;
    return async dispatch => {
        dispatch({
            type: types.GET_INVALSI_SUBJECTS_LIST
        });
        try {
            const { data } = await axios.get(`${url}&etag=${Math.random() * 1000}`);
            dispatch({
                type: types.GET_INVALSI_SUBJECTS_LIST_SUCCESS,
                result: data
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: types.GET_INVALSI_SUBJECTS_LIST_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: types.GET_INVALSI_SUBJECTS_LIST_FAILURE,
                    error: e
                });
            }
        }
    };
}

export function getInvalsiTaxonomy(subjects) {
    const url = `${API_URL}/taxonomies/contents/cv`;

    let params = 'origin=INVALSI';
    if (subjects) {
        let sSubjects = JSON.stringify(subjects);
        params = `${params}&subjects=${sSubjects}`;
    }

    return async dispatch => {
        dispatch({
            type: types.GET_INVALSI_CONTENT_TAXONOMY
        });
        try {
            const { data } = await axios.get(`${url}?${params}&etag=${Math.random() * 1000}`);
            dispatch({
                type: types.GET_INVALSI_CONTENT_TAXONOMY_SUCCESS,
                result: data
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.GET_INVALSI_CONTENT_TAXONOMY_FAILURE,
                error: e
            });
        }
    };
}

export function getInvalsiYears(subjects) {
    const url = `${API_URL}/taxonomies/years/cv`;
    let params = '';
    if (subjects) {
        let sSubjects = JSON.stringify(subjects);
        params = `subjects=${sSubjects}&`;
    }

    return async dispatch => {
        dispatch({
            type: types.GET_INVALSI_YEARS_LIST
        });
        try {
            const { data } = await axios.get(`${url}?${params}etag=${Math.random() * 1000}`);
            dispatch({
                type: types.GET_INVALSI_YEARS_LIST_SUCCESS,
                result: data
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: types.GET_INVALSI_YEARS_LIST_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: types.GET_INVALSI_YEARS_LIST_FAILURE,
                    error: e
                });
            }
        }
    };
}

export function getInvalsiItemTypes(subjects) {
    const url = `${API_URL}/taxonomies/itemTypes/cv`;
    let params = 'includeTheories=0&origin=INVALSI';
    if (subjects) {
        let sSubjects = JSON.stringify(subjects);
        params = `${params}&subjects=${sSubjects}`;
    }
    return {
        types: [types.GET_INVALSI_ITEM_TYPES, types.GET_INVALSI_ITEM_TYPES_SUCCESS, types.GET_INVALSI_ITEM_TYPES_FAILURE],
        promise: axios.get(`${url}?${params}&etag=${Math.random() * 1000}`, {
            withCredentials: true
        })
    };
}

export function getInvalsiExercises(
    traceData = {},
    subjectsId,
    fromYearOrdinal,
    toYearOrdinal,
    taxonomyIdList,
    itemTypesId,
    favouriteOnly,
    searchTerm,
    isSuggestionSelected,
    searchPage = 0
) {
    searchPage++;
    return async dispatch => {
        dispatch({
            type: searchPage === 1 ? types.GET_INVALSI_EXERCISE_LIST : types.GET_MORE_INVALSI_EXERCISE_LIST,
            subjectsId,
            fromYearOrdinal,
            toYearOrdinal,
            taxonomyIdList,
            itemTypesId,
            favouriteOnly,
            searchTerm,
            isSuggestionSelected,
            traceData
        });
        try {
            const {
                data: { data, totalCount }
            } = await axios.post(`${API_URL}/cv/getItemsByContentPaths`, {
                contentPath: taxonomyIdList,
                subjects: Array.isArray(subjectsId) && subjectsId.length > 0 ? subjectsId : undefined,
                fromChapterOrdinal: fromYearOrdinal ? fromYearOrdinal : undefined,
                toChapterOrdinal: toYearOrdinal ? toYearOrdinal : undefined,
                itemTypes: Array.isArray(itemTypesId) && itemTypesId.length > 0 ? itemTypesId : undefined,
                page: searchPage,
                origin: 'INVALSI',
                favourites: favouriteOnly
            });
            dispatch({
                type: searchPage === 1 ? types.GET_INVALSI_EXERCISE_LIST_SUCCESS : types.GET_MORE_INVALSI_EXERCISE_LIST_SUCCESS,
                result: data.map(e => ({ ...fixExerciseStructure(e), contextId: getContextId(taxonomyIdList) })),
                totalCount,
                searchPage: searchPage,
                favourites: favouriteOnly
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: types.GET_INVALSI_EXERCISE_LIST_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: types.GET_INVALSI_EXERCISE_LIST_FAILURE,
                    error: e
                });
            }
        }
    };
}

export function onInvalsiFiltersChange(filters, isExercise) {
    return dispatch => {
        dispatch({
            type: types.INVALSI_FILTERS_CHANGE,
            filters: filters,
            isExercise: isExercise
        });
    };
}
